module.exports = __webpack_public_path__ + "img/footer_free _shipping.92cb0486.png";